import { useEffect, useState } from 'react';

/**
 * The order ids behind the rows the deliveries table has selected.
 *
 * The table selects `delivery_id`, but the bulk endpoints match on
 * `order__id__in` — preparing, changing status, assigning a driver, ceding to a
 * partner and the labels of a selection. Two currencies for the same shipments,
 * and handing one where the other is expected only looks right on a database
 * where both sequences happen to line up.
 *
 * The pair is remembered as rows go by rather than looked up in the current
 * page, because a selection survives paging and by then the old rows are gone.
 *
 * @param {Array<{delivery_id: number, order_id: number}>} data - Current page
 * @param {Array<number>} selectedRows - Delivery ids the table has selected
 * @returns {Array<number>} The matching order ids
 */
export const useSelectedOrderIds = (data, selectedRows) => {
  const [orderIdByDelivery, setOrderIdByDelivery] = useState({});

  useEffect(() => {
    if (!data || data.length === 0) return;
    setOrderIdByDelivery((prev) => {
      const next = { ...prev };
      data.forEach((row) => { next[row.delivery_id] = row.order_id; });
      return next;
    });
  }, [data]);

  return selectedRows
    .map((deliveryId) => orderIdByDelivery[deliveryId])
    .filter((orderId) => orderId !== undefined);
};
